import { useFetch } from '@reveni-io/reveni-ui'

import parcelServices from '@/parcels/services/services'

const useMarkParcelAlertAsRead = ({ storeId, parcelId, refetchParcel }) => {
  const { fetchData, loading } = useFetch(() => parcelServices.markParcelAlertAsRead({ storeId, parcelId }), {
    doInitialRequest: false,
  })

  const markParcelAlertAsRead = async () => {
    await fetchData()
    await refetchParcel()
  }

  return {
    markParcelAlertAsRead,
    markingParcelAlertAsRead: loading,
  }
}

export default useMarkParcelAlertAsRead
